import modal from './modal';
const form = () => {
    // Forms

    const forms = document.querySelectorAll('form');
    const message = {
        loading: 'img/form/spinner.svg',
        success: 'Дані відправлені оператору. Скоро він вам зателефонує',
        failure: 'Щось пішло не так'
    };

    forms.forEach(item => {
        bindPostData(item);
    })

    const postData = async (url, data) => {
        let res = await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: data
        });

        return await res.json();
    };
    function bindPostData(form){
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const statusMessage = document.createElement('img');
            statusMessage.src = message.loading;
            statusMessage.style.cssText = `
                display: block;
                margin: 20px auto 0px;
            `;
            form.insertAdjacentElement('afterend', statusMessage);



            const formData = new FormData(form);

            const json = JSON.stringify(Object.fromEntries(Object.entries(formData)))

            postData('http://localhost:3000/requests', json)
                .then((data) => {
                    showThanksModal(message.success);
                    console.log(data)
                    statusMessage.remove();
                }).catch(() => {
                showThanksModal(message.failure)
            }).finally(() => {
                form.querySelectorAll('input').forEach(input => {
                    input.value = "";
                    statusMessage.remove();
                })
            })
        })
    }

    function showThanksModal (message) {
        const prevModalDialog = document.querySelector('.modal__dialog');

        prevModalDialog.classList.remove('show');
        prevModalDialog.classList.add('hide');
        openModal();

        const modalDialog = document.createElement('div');
        modalDialog.classList.add('modal__dialog');
        modalDialog.innerHTML = `
            <div class="modal__content">
                <div class="modal__close" data-close>×</div>
                <div class="modal__title">${message}</div>
            </div>
        `;

        document.querySelector('.modal').append(modalDialog);
        setTimeout(function (){
            modalDialog.remove();
            prevModalDialog.classList.add('show');
            prevModalDialog.classList.remove('hide')
            closeModal();
        }, 4000)

    }
}
export default form;